import { Button, Drawer, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
// import { UserInfo } from "../../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import { UserInfo } from "../../../context";

const RawProcessDetails = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);
  const [total, setTotal] = useState(0);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["processsaverawproduct", "product"],
    },
    {
      title: "Description",
      dataIndex: ["processsaverawproduct", "description"],
    },
    {
      title: "Unit",
      dataIndex: ["processsaverawproduct", "rawproductsuserunit", "unit"],
      align: "right",
    },
    {
      title: "Qty * Price",
      // dataIndex: "quantity",
      align: "right",
      render: (text, record) => (
        <>
          {text.quantity} * {text.processsaverawproduct.purchase_price}
        </>
      ),
    },
    {
      title: "Amount",
      // dataIndex: ["processsaverawproduct", "rawproductsuserunit", "unit"],
      align: "right",
      render: (text, record) => (
        <>
          {parseFloat(
            parseFloat(text.quantity) *
              parseFloat(text.processsaverawproduct.purchase_price)
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  //   console.log("selectedData", selectedData);

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      track_id: selectedData !== null ? selectedData.track_id : "",
    };
    axios
      .get("user/commissary/spec-raw-process-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setOrderDetailsList({ data, ready: true });
        setTotal(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(data[i].processsaverawproduct.purchase_price) *
        parseFloat(data[i].quantity);
    }
    return total;
  };

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Production Details"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {/* {console.log("selectedData", selectedData)} */}

      {selectedData !== null && (
        <div
          style={{ overflowX: "auto", padding: paddingPrint }}
          ref={componentRef}
        >
          {displayDetailsPrint && (
            <Typography.Title level={4} style={{ marginBottom: 15 }}>
              {selectedData.track_id} - Production
            </Typography.Title>
          )}
          <Typography level={4}>
            Created Product:{" "}
            <b>{selectedData.processsaverawproduct2.product}</b>
          </Typography>
          <Typography level={4}>
            Created Ref.#: <b>{selectedData.track_id}</b>
          </Typography>
          <Typography level={4}>
            Output: <b>{selectedData.expected_quantity}</b>
          </Typography>
          <Typography level={4}>
            Remarks: <b>{selectedData.remarks}</b>
          </Typography>
          <Typography level={4}>
            Note: <b>{selectedData.note}</b>
          </Typography>
          {parseInt(
            orderDetailsList.ready &&
              orderDetailsList.data.length > 0 &&
              orderDetailsList.data[0].multiple
          ) > 1 && (
            <Typography level={4}>
              Multiple Production: <b>X{orderDetailsList.data[0].multiple}</b>
            </Typography>
          )}
          <Table
            {...tableProps}
            // pagination={{
            //   position: ["bottomRight"],
            // }}
            pagination={false}
            columns={tableColumns}
            dataSource={
              orderDetailsList.data.length > 0 ? orderDetailsList.data : []
            }
            scroll={scroll}
            rowKey={(record) => record.raw_id}
            footer={() => (
              <div style={{ display: "flex" }}>
                <div style={{ flexGrow: 1 }} />
                <Typography level={4} align="right">
                  Total:{" "}
                  {total.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </div>
            )}
          />
        </div>
      )}

      <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ flexGrow: 1 }} />
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default RawProcessDetails;
